module.exports = __webpack_public_path__ + "img/bottle_refill.5258633b.jpg";